"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContextTypeByPageSetLayer = void 0;
// This mapping can be used when multiple layers are used in a single context, i.e.
//   {
//     'payment-survey': 'payment',
//     'payment-checkout': 'payment',
//   }
const pageSetContextTypeMappings = {};
function getContextTypeByPageSetLayer(pageSetLayer) {
    return pageSetContextTypeMappings[pageSetLayer] || pageSetLayer;
}
exports.getContextTypeByPageSetLayer = getContextTypeByPageSetLayer;
//# sourceMappingURL=pageset.js.map